import api from '../../utils/api';
import { alertSuccess, alertError } from './alert';

let cancelExport;
export const exportProducts = () => async (dispatch, getState) => {
  try {
    if (cancelExport) {
      cancelExport('Cancel products export');
    }

    const { supplierId } = getState().role;
    const response = await api.get(`/suppliers/${supplierId}/variants?csv=true`, {
      cancelToken: new api.CancelToken((c) => (cancelExport = c)),
    });

    if (response && response.status === 200 && response.data === 'OK') {
      dispatch(alertSuccess('Products export will be sent via email'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};
